// import masonry from "../../jquery/lsag.masonry";
import pagination from "../../jquery/lsag.pagination";

class LoadMoreProductsController {
    /*@ngInject*/
    constructor($log, $http, $rootScope, $compile, $scope) {
        $log.debug('LoadMoreProductsController initialized');
        this.$http = $http;
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.loadMoreResponse = null;
        this.$compile = $compile;
        this.$scope = $scope;
    }

    loadProducts(e) {
        // chrome scroll fix - leave focus on load more button
        $(e.currentTarget).blur();
        pagination.backUrl = $(e.currentTarget).data('back-url');
        let url = $(e.currentTarget).data('next-url');
        let req = {
            method: 'GET',
            url: url,
            cache: false
        };

        this.$http(req).then((response) => {
            this.loadMoreResponse = response.data;

            let newProducts = $(this.loadMoreResponse).filter('.productcell');

            // $(masonry.grid).append(this.$compile(newProducts)(this.$scope));
            // masonry.masonry.appended(newProducts);
            // masonry.masonry.layout();

            let paginationUrl = $(this.loadMoreResponse).filter('#pagination-url');
            let backUrl = paginationUrl.data('back-url');
            let nextUrl = paginationUrl.data('next-url');
            let loadButton$ = $('#load-more');

            if (nextUrl !== undefined) {
                loadButton$.data('next-url', nextUrl);
                loadButton$.data('back-url', backUrl);
            } else {
                loadButton$.remove();
            }

            this.$rootScope.$broadcast('loadMoreProductsSuccess');

        }, (error) => {
            this.$log.error('Load more products: ' + error.status + ' ' + error.statusText);
        });
    }
}

export default LoadMoreProductsController;
